import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {topicsData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{topicsData.subtitle}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.items.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 text-primary-700 border border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 text-foreground-600 border border-background-200 hover:bg-background-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-primary-500 text-xs"></i>}
              {topic.label}
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}